import { render } from "./FileComments.vue?vue&type=template&id=a33e8d28"
import script from "./FileComments.vue?vue&type=script&lang=js"
export * from "./FileComments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__